import React from 'react';
import validator from 'validator';
import {
  Edit,
  EditController,
  TabbedForm,
  FormTab,
  CardActions,
  ListButton,
  ShowButton,
} from 'react-admin';
import { Card, CardContent, CircularProgress } from '@material-ui/core';
import SaveOnlyToolbar from '../SaveOnlyToolbar';
import BasicInformation from './children/BasicInformation';
import EmploymentFinances from './children/EmploymentFinances';
import TrustedContact from './children/TrustedContact';
import Identity from './children/Identity';
import UserHistoryAndDocs from './children/UserHistoryAndDocs_Show';
import FolioData from './children/FolioData_Show';

const Title = ({ record }) => (
  <span>User: <strong>{record.firstName} {record.lastName}</strong> ({record.email})</span>
);

const Actions = ({ basePath, data }) => (
  <CardActions>
    <ShowButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

const redirect = (basePath, id) => `${basePath}/${id}/show`;

const validateTrustedContact = (values) => {
  let errors = {};
  if (values.trustedContact) {
    errors.trustedContact = {};
    if (!values.trustedContact.firstName) {
      errors.trustedContact.firstName = ['First name is required'];
    } else if (values.trustedContact.firstName && !validator.isAlpha(values.trustedContact.firstName)) {
      errors.trustedContact.firstName = ['First name is not valid. Use only letters.'];
    }
    if (!values.trustedContact.lastName) {
      errors.trustedContact.lastName = ['Last name is required'];
    } else if (values.trustedContact.lastName && !validator.isAlpha(values.trustedContact.lastName)) {
      errors.trustedContact.lastName = ['Last name is not valid. Use only letters.'];
    }
    if (!values.trustedContact.email) {
      errors.trustedContact.email = ['Email is required'];
    } else if (values.trustedContact.email && !validator.isEmail(values.trustedContact.email)) {
      errors.trustedContact.email = ['Email is not valid'];
    }
    if (!values.trustedContact.telephone) {
      errors.trustedContact.telephone = ['The telephone is required'];
    } else if (values.trustedContact.telephone && !validator.isMobilePhone(values.trustedContact.telephone)) {
      errors.trustedContact.telephone = ['The telephone format is not correct'];
    }

    if (!values.trustedContact.firstName && !values.trustedContact.lastName
      && !values.trustedContact.email && !values.trustedContact.telephone) {
      errors = {};
    }
  }

  return errors;
};

export default props =>
  (
    <EditController {...props}>
      {(controllerProps) => {
      if (controllerProps.isLoading && !controllerProps.record) {
        return <Card><CardContent style={{ textAlign: 'center' }}><CircularProgress /><br /><br /><span className="normalField">Fetching data</span></CardContent></Card>;
      }
        return (
          <Edit
            {...props}
            title={<Title />}
            actions={<Actions />}
            undoable={false}
          >
            <TabbedForm redirect={redirect} toolbar={<SaveOnlyToolbar />} validate={validateTrustedContact}>
              <FormTab label="Basic"><BasicInformation /></FormTab>
              {controllerProps.record && controllerProps.record.signUpCompletedAt && <FormTab label="Identity"><Identity /></FormTab>}
              {controllerProps.record && controllerProps.record.signUpCompletedAt && <FormTab label="Trusted Contact"><TrustedContact /></FormTab>}
              {controllerProps.record && controllerProps.record.signUpCompletedAt && <FormTab label="Employment, Finances, and Disclosures"><EmploymentFinances /></FormTab>}
              <FormTab label="Action History &amp; Documents"><UserHistoryAndDocs /></FormTab>
              {controllerProps.record && controllerProps.record.signUpCompletedAt && <FormTab label="FOLIO Data"><FolioData /></FormTab>}
            </TabbedForm>
          </Edit>
        );
      }}
    </EditController>
  );



// WEBPACK FOOTER //
// ./src/components/User/Edit.jsx